import { render, staticRenderFns } from "./DialogDT.vue?vue&type=template&id=74fb1a10&scoped=true&"
import script from "./DialogDT.vue?vue&type=script&lang=js&"
export * from "./DialogDT.vue?vue&type=script&lang=js&"
import style0 from "./DialogDT.vue?vue&type=style&index=0&id=74fb1a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb1a10",
  null
  
)

export default component.exports